import DropdownToggle from '../../../DropdownToggle/index';

import styles from './FooterNavGroupTitle.module.css';

export const FooterNavGroupTitle = ({ isOpen, title, toggle }: { isOpen: boolean; title: string; toggle(): void }) => (
  <div
    className={`${styles.footerNavGroupTitleWrapper} ${isOpen ? styles.footerNavGroupTitleWrapperOpen : ''}`}
    onClick={toggle}
  >
    <p className={styles.footerNavGroupTitleText}>{title}</p>
    <DropdownToggle isOpen={isOpen} />
  </div>
);
